import { useState, useEffect } from "react"

import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  Card,
  CardContent,
} from '@mui/material'

import { aiQcService, handleApiError, type AIQCReview } from "../api"
import { ReviewedTable } from "../components/ai-qc/reviewed-table"

export default function AIQCReviewedPage() {
  const [reviewedItems, setReviewedItems] = useState<AIQCReview[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const loadReviews = async () => {
    try {
      const allReviews = await aiQcService.getAllReviews()
      // Filter for reviewed items (approved or rejected)
      const reviewed = allReviews.filter(review =>
        review.status === 'approved' || review.status === 'rejected'
      )
      setReviewedItems(reviewed)
      setError("")
    } catch (err) {
      setError(handleApiError(err))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadReviews()
  }, [])

  if (loading) {
    return (
      <Box sx={{ flex: 1, p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box sx={{ flex: 1, p: 3 }}>
      <Card sx={{ height: 'fit-content' }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h4" component="h1" fontWeight="bold" sx={{ mb: 3 }}>
            Reviewed
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Card variant="outlined" sx={{ mt: 2 }}>
            <CardContent sx={{ p: 0 }}>
              {reviewedItems.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 8 }}>
                  <Typography variant="body1" color="text.secondary">
                    No reviewed items yet.
                  </Typography>
                </Box>
              ) : (
                <ReviewedTable reviews={reviewedItems} />
              )}
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </Box>
  )
}
